module.exports = __webpack_public_path__ + "static/img/audiocontrol.62bb4c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meetingcontrol/black/audiocontrol.png
// module id = l1KV
// module chunks = 1